module.exports = __webpack_public_path__ + "static/story5-01-800x533-392589395a44688954782689f1cac0d9.jpg";